import { configureStore } from "@reduxjs/toolkit";
import bookingsReducer from "./slices/bookingsSlice";
import bookingIntakeReducer from "./slices/bookingIntakeSlice";
import medicalInfoReducer from "./slices/medicalInfoSlice";
import docsReducer from "./slices/docsSlice";
import bookingPhotoReducer from "./slices/bookingPhotoSlice";
import refListReducer from "./slices/refListSlice";
import configReducer from "./slices/configSlice";
import staffGroupsReducer from "./slices/staffGroupsSlice";
import bookingQueueReducer from "./slices/bookingQueueSearchSlice";
import globalCriteriaReducer from "./slices/globalCriteriaSlice";
import staffGroupMembersReducer from "./slices/staffGroupMembersSlice";
import securityRulesFuncReducer from "@/slices/securityRulesFunctionalitySlice";
import securityRulesRecordsReducer from "@/slices/securityRulesRecordsSlice";
import securityRulesCriteriaReducer from "@/slices/securityRulesCriteriaSlice";
import tableNamesReducer from "@/slices/tableNameSlice";
import clientParamsReducer from "./slices/clientParamsSlice";
import userDetailSlice from "./slices/userDetailDetail";
import staffSlice from "./slices/staff/staffSlice";
import batchInmateMovementSlice from "./slices/batchInmateMovementSlice";
import intakeQueueReducer from "./slices/intakeQueueSlice";
import fullSearch from "./slices/fullSearchSlice";
import lineups from "./slices/lineupsSlice";
import jailIncidentReducer from "./slices/jailIncidents";

export default configureStore({
  reducer: {
    bookings: bookingsReducer,
    bookingIntake: bookingIntakeReducer,
    medicalData: medicalInfoReducer,
    docsData: docsReducer,
    imgData: bookingPhotoReducer,
    refListReducer: refListReducer,
    config: configReducer,
    staffGroups: staffGroupsReducer,
    bookingQueue: bookingQueueReducer,
    globalCriteria: globalCriteriaReducer,
    staffGroupMembers: staffGroupMembersReducer,
    securityRulesFunctionality: securityRulesFuncReducer,
    securityRulesRecords: securityRulesRecordsReducer,
    securityRulesCriteria: securityRulesCriteriaReducer,
    tableNames: tableNamesReducer,
    clientParams: clientParamsReducer,
    userDetail: userDetailSlice,
    staff: staffSlice,
    batchInmateMovement: batchInmateMovementSlice,
    intakeQueue: intakeQueueReducer,
    fullSearch: fullSearch,
    lineups: lineups,
    jailIncident: jailIncidentReducer,
  },
});
